import React, { Fragment } from 'react'
import FormElement from '../../../common/formComponents/FormElement'
import Form from '../../../common/formComponents/Form'

import './AdministrativeInsertion.css'
import moment from 'moment'
import withPolyglot from '../../../common/withPolyglot'
import { INSERTION_TYPE } from '../../../../resources/utilities'
import ImmunizationInsertionContainer
  from '../../PatientsViewer/PatientViewer/ImmunizationInsertion/ImmunizationInsertionContainer'
import { Link } from 'react-router-dom'

function isFaded (param) {
  return param ? '' : 'faded'
}

const SelectedPatient = ({patient, removePatient, selectPreviousInsertion, immunizations, translate}) => {
  return <Fragment>
    <ImmunizationInsertionContainer />
    <div className='uk-width-1-1'>
      <h4 className='uk-align-left'>{patient.name} - {patient.id}</h4>
      <button className='uk-button uk-align-right uk-button-primary' onClick={removePatient}>{translate('changePatient')}</button>
    </div>
    <div className='uk-overflow-auto uk-width-1-1'>
      <table className='uk-table uk-table-middle uk-table-striped shots-table'>
        <thead>
          <tr>
            <th>{translate('date')}</th>
            <th>{translate('pathologies')}</th>
            <th>{translate('observations')}</th>
            <th>{translate('adverseReaction')}</th>
          </tr>
        </thead>
        <tbody>
          {immunizations.map((immuno, i) => {
            return <tr key={i}>
              <td className='uk-table-shrink'>{moment(immuno.date).format('L')}</td>
              <td className='uk-table-expand'>
                <ul className='uk-list'>
                  {immuno.protoInfo.map((item, i) => <li className='' key={i}>{translate(item.pathology.displayKey, true, 'pathologies')}</li>)}
                </ul>
              </td>
              <td className={isFaded(immuno.observations)}>{immuno.observations || translate('notDefined')}</td>
              <td className={isFaded(immuno.adverseReactionId)}>{immuno.adverseReactionId ? translate('positive') : translate('negative')}</td>
            </tr>
          })
          }
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4}>
              <button className='uk-button uk-align-center uk-button-primary' onClick={() => {
                console.log('Hi')
                selectPreviousInsertion(INSERTION_TYPE.PREVIOUS)
              }}>{translate('addShot')}</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <ul />
  </Fragment>
}

const SelectPatientForm = ({selectPatient, translate}) => {
  return <Form type={'horizontal'} handleSubmit={({patientNumber}) => { selectPatient(patientNumber) }}>
    <FormElement required type={'number'} label={''} placeholder={translate('patientNumber')} name={'patientNumber'} />
    <button
      className='uk-button uk-button-primary uk-align-right uk-margin-small'
      type='submit'>{translate('submit')}
    </button>
  </Form>
}

const AdministrativeInsertion = ({match, currentUrl, translate, selectPatient, immunizations, patient, removePatient, selectPreviousInsertion}) => {
  return <div className='uk-container uk-margin-medium-top administrative-container'>
    <div className='uk-width-1-1 uk-clearfix'>
      <Link to={`${match.url}/new`}>
        <button
          onClick={() => {}}
          className='uk-button uk-button-primary uk-align-center uk-margin-small'
          type=''>{translate('insertNewPatient')}
        </button>
      </Link>
    </div>
    {patient
      ? <SelectedPatient
        translate={translate}
        immunizations={immunizations}
        patient={patient}
        removePatient={removePatient}
        selectPreviousInsertion={selectPreviousInsertion} />
      : <SelectPatientForm translate={translate} selectPatient={selectPatient} />
    }
  </div>
}

export default withPolyglot(AdministrativeInsertion, 'administrativeInsertion')
